import React, { useRef } from "react";
import { Headings } from "@project-stories/elements/Headings/Headings";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import { ProductTile } from "@project-stories/ecommerce/Product/ProductTile";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import ListProductsCTA from "@src/stories/sections/ListProducts/ListProductsCTA/ListProductsCTA";
import CarouselNavigation from "@src/stories/client/NavigationElements/CarouselNavigation";

export default function ListProductsDefault({ products, settings }) {
  const { section, mobile_breakpoint } = settings;
  const isMobile = useMobileBreakpoint(mobile_breakpoint);
  let ctaPosition = "top";
  const carouselListRef = useRef(null);

  if (isMobile) {
    ctaPosition = "bottom";
  }

  return (
    <div className="product-list default-list">
      <div className={"section-top"}>
        <div className={"section-bar w-full flex flex-row justify-between"}>
          <div className={"section-info"}>
            <Headings text={section?.title} type={section?.header_style} />
            <Paragraph text={section?.subtext} type={section?.subtext_style} />
          </div>
          {ctaPosition === "top" && (
            <ListProductsCTA section={section} isMobile={isMobile} />
          )}
        </div>
      </div>

      <div className={"w-full"} x-data="carouselFilter()">
        <div className="row-start-1 col-start-1">
          <div className="carousel-item-container w-full">
            <div
              className="carousel w-full"
              x-ref="carousel"
              x-data="carousel"
              ref={carouselListRef}
            >
              {products.map((product, id) => (
                <div
                  key={id}
                  className="carousel-item"
                  x-init={`$nextTick(() => { initialise(${section.show_indicators}, ${section.show_navbuttons}, ${section.fade_edgeitems}, false, false, 'products', false, ${section.use_freescroll}) })`}
                >
                  <ProductTile
                    product={product}
                    swatches={product?.swatches}
                    siblings={undefined}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div
        className={
          "section-bottomrow flex flex-row justify-between items-center w-full mt-[12px]"
        }
      >
        <CarouselNavigation
          shiftPageDots={true}
          carouselRef={carouselListRef}
        />
      </div>

      <div className={"section-bottom flex justify-center mt-4"}>
        {ctaPosition === "bottom" && (
          <ListProductsCTA section={section} isMobile={isMobile} />
        )}
      </div>
    </div>
  );
}
